module.exports = __webpack_public_path__ + "img/lasource-20.6eb59d15.jpg";